// extracted by mini-css-extract-plugin
export default {"scrollProgressBar":"scrollProgressBar_scrollProgressBar__+1Z7e"};